import '/assets/styles/sections/upcoming-events.scss';
import classNames from 'classnames';
import { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Slider from '/views/partials/slider';
import Placeholder from '/views/partials/placeholder';
import Btn from '/views/partials/btn';
import Eventbox from '/views/partials/eventbox-old';

// Services
import siteServices from '/services/site';

// Context
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';
import { useLocations } from '/utilities/locations';

const SHOWCASE_KEY = 'UPCOMING_EVENT';

const getUpcomingEvents = (location) => {
	return siteServices.getShowcase('UPCOMING_EVENT', { location });
}

const UpcomingEvents = ({ id }) => {
	const { selectedLocation: defaultSelectedLocation, locationOptions } = useLocations();
	const { desktop } = useBreakpoints();
	const [data, setData] = useState(null);

	const [selectedLocation, setSelectedLocation] = useState(defaultSelectedLocation)

	useEffect(() => {
		setData(null);
		getUpcomingEvents(selectedLocation?.city).then((setData)).catch(() => {
			setData(undefined);
		})
	}, [selectedLocation])

	const analyticsListInfo = useMemo(() => (data?.title ? {
		listId: SHOWCASE_KEY,
		listName: data.title,
	} : undefined), [data]);
	
	const events = useMemo(() => {
		const processedEvents =  data ? data.events : [false, false, false, false];

		return desktop ? processedEvents : processedEvents.slice(0, 3);
	}, [data, desktop])

	return (
		<section className="section upcomingevents">
			<div className="upcomingevents-wrap wrapper narrow">
				{data ?
					<h2 className="upcomingevents-title">
						{data.icon &&
							<Icon name={data.icon} className="title-icon" />
						}
						<span className="title-text">{data.title}</span>
					</h2>
					:
					<div className="upcomingevents-title">
						<Placeholder className="title-icon" />
						<Placeholder className="title-text" />
					</div>
				}

				<div className="upcomingevents-filters">
					<div className="filters-locations">
						{desktop &&
							<strong className="locations-title">Nerede?</strong>
						}
						{locationOptions.map((branch) => (
							<button
								type="button"
								key={branch?.id ?? 'empty'}
								onClick={() => { setSelectedLocation(branch); }}
								className={classNames('locations-item', { selected: branch.id === selectedLocation.id })}>
								<span className="item-check"></span>
								<span>{branch.shortTitle}</span>
							</button>
						))}
					</div>
				</div>

				{desktop ?
					<Slider
						className="upcomingevents-slider"
						id={`${id ?? 'upcomingevents'}-slider`}
						key={`upcomingevents-slider-${data?.events ? 'has-data' : 'no-data'}`}
						navigation={true}
						params={{
							slidesPerView: desktop ? 4 : 1,
						}}>
						{events.map((event, nth) => (
							<Eventbox
								key={event?.id ?? nth}
								event={event}
								analytics={analyticsListInfo}
								className="upcomingevents-event" />
						))}
					</Slider>
					:
					<ul className="upcomingevents-list">
						{events.map((event, nth) => (
							<li className="list-item" key={event?.id ?? nth}>
								<Eventbox
									type="horizontal"
									event={event}
									analytics={analyticsListInfo}
									className="upcomingevents-event" />
							</li>
						))}
					</ul>
				}

				<Btn
					tag="link"
					href="events"
					className="upcomingevents-cta block text big outline">
					Tümünü Gör
				</Btn>
			</div>
		</section>
	)
}

UpcomingEvents.propTypes = {
	id: PropTypes.string,
}

export default UpcomingEvents;